<template>
  <div class="container">
    <div class="box" ref="printBox"  v-for="(item, index) in allData"
      :key="index">
      <div class="title"><span id="payTitle">水费收款凭证</span></div>
      <div class="date">打印日期: {{ item.printDate }}</div>
      <div class="tableStyle">
        <el-table :data="item.bodyList" border="" style="width: 100%">
           <el-table-column type="index" width="55" align="center" label="序号">
          </el-table-column>
          <el-table-column prop="lesseeName" label="商铺名称" align="center">
          </el-table-column>
          <el-table-column prop="lesseeCode" label="商铺编号" align="center" width="120">
          </el-table-column>
          <el-table-column prop="payType" label="支付方式" align="center" width="90">
          </el-table-column>
          <el-table-column prop="number" label="数量(次)" align="center" width="90">
          </el-table-column>
           <el-table-column
            prop="payDate"
            label="收款日期"
            width="150"
            align="center"
          >
          </el-table-column>
          <el-table-column
                  prop="fee"
                  label="水费"
                  width="80"
                  align="center"
                  v-if="openServiceFee"
          >
          </el-table-column>
          <el-table-column
                  prop="serviceFee"
                  :label="serviceFeeColumnName"
                  width="80"
                  align="center"
                  v-if="openServiceFee"
          >
          </el-table-column>
          <el-table-column prop="money" label="支付金额(元)" align="center"  width="120">
          </el-table-column>
        </el-table>
      </div>
      <div class="total">
        <el-row :gutter="20" class="totalRow">
          <el-col :span="8">
            合计（大写）：<span> {{ item.totalCapitalMoney }}</span>
          </el-col>
          <el-col :span="8">
            合计（小写）：<span> {{ item.totalMoney }}</span>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8"> 部门：<span> </span> </el-col>
          <el-col :span="8"> 经办人：<span> </span> </el-col>
          <el-col :span="8"> 审核人：<span> </span> </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
// import print from 'print-js';
import { getPrintData } from '../../api/water/sellWaterRecord';
export default {
  data() {
    return {
      nowDate: '',
      allData: [],
      serviceFeeColumnName: '',
      openServiceFee: false
    };
  },
  created() {
    let specificDate = new Date(2025, 10, 1, 0, 0, 0);
    let now = new Date();
    if(now.getTime() > specificDate.getTime()){
      this.openServiceFee = true;
    }
    this.serviceFeeColumnName = this.$route.query.serviceFeeColumnName;
    this.init();
  },
  mounted() {},
  watch: {},
  methods: {
    async init() {
      // this.getNowTime();
      await this.getParams();
      window.print();
    },
     //显示当前时间
    getNowTime() {
      let now = new Date(),
        year = now.getFullYear(), //得到年份
        month = now.getMonth() + 1, //得到月份
        day = now.getDate(); //得到日期
      this.nowDate = year + '年' + month + '月' + day + '日';
    },
    async getParams() {
      let orderNos = JSON.parse(this.$route.query.multipleSelection);
      for (let i = 0; i < orderNos.length; i++) {
        const res = await getPrintData(orderNos[i]).then();
        this.allData.push(res.data);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
}
/deep/ .el-table .cell {
  color: #000 !important;
  font-size: 16px;
}
.box:nth-child(3n) {
  page-break-after: always;
}
.box {
  width: 1000px;
  height: 450px;
  padding: 30px 50px;
  background-color: #fff;
  box-sizing: border-box;
  border-bottom: 2px dashed #000;
  .title {
    width: 100%;
    text-align: center;
    /deep/ span {
      font-weight: bold;
      letter-spacing: 5px;
      color: #000;
      font-size: 32px;
      display: inline-block;
      padding: 10px 20px;
      border-bottom: 3px double #000;
    }
  }
  .date {
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-align: right;
    color: #000;
    padding-right: 20px;
  }
  .total {
    // margin-top: 20px;
    .el-row {
      line-height: 40px;
    }
  }
}
.btns {
  width: 1000px;
  margin: 0 auto;
  margin-top: 20px;
  text-align: center;
}
.el-table {
  width: fit-content;
}
.totalRow {
  border: 1px solid #000;
  border-top: 0;
}
/deep/ .el-row {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
/**
改变边框颜色
 */
.el-table--border,
.el-table--group {
  border: 2px solid #000 !important;
}
/**
改变表格内竖线颜色
 */
/deep/ .el-table--border td,
/deep/ .el-table--border th,
/deep/
  .el-table__body-wrapper
  .el-table--border.is-scrolling-left
  ~ .el-table__fixed {
  border-right: 1px solid #000 !important;
}
/**
改变表格内行线颜色
 */

/deep/ .el-table th.is-leaf {
  border-bottom: 3px solid #000 !important;
}

/deep/ .el-table thead tr th {
  border-color: #000;
  background-color: #fff !important;
}
/deep/ .el-table--border::after,
.el-table--group::after,
/deep/ .el-table::before {
  width: 0 !important;
}
@page {
  size: auto; /* auto is the initial value */
  margin: 0mm; /* this affects the margin in the printer settings */
}
</style>
